import { useEffect } from "react";

interface PageMeta {
  title: string;
  description: string;
  keywords: string;
}

function upsertMeta(name: string, content: string, attr: "name" | "property" = "name") {
  let tag = document.querySelector(`meta[${attr}="${name}"]`);
  if (!tag) {
    tag = document.createElement("meta");
    tag.setAttribute(attr, name);
    document.head.appendChild(tag);
  }
  tag.setAttribute("content", content);
}

export function usePageMeta({ title, description, keywords }: PageMeta) {
  useEffect(() => {
    document.title = title;
    upsertMeta("description", description);
    upsertMeta("keywords", keywords);
    upsertMeta("og:title", title, "property");
    upsertMeta("og:description", description, "property");
  }, [title, description, keywords]);
}